// Auto-generated from OracyAI_Terms_and_Conditions_India.docx (interim version, 1 June 2025).
// Replace when the lawyer-vetted / Hindi final version lands.
import type { LegalBlock } from "./LegalPage";

export const termsBlocks: LegalBlock[] = [
  {
    "type": "p",
    "text": "OracyAI (myoracy.ai) | India"
  },
  {
    "type": "p",
    "text": "Effective Date: 1 June 2025"
  },
  {
    "type": "p",
    "text": "These Terms and Conditions govern your access to and use of the OracyAI platform at myoracy.ai, operated by Oracy Group. By accessing or using the platform, you agree to be bound by these Terms. If you are accessing the platform on behalf of a school or educational institution, you agree on behalf of that institution."
  },
  {
    "type": "p",
    "text": "These Terms are governed by and interpreted in accordance with the laws of India, including the Digital Personal Data Protection Act, 2023 and the Information Technology Act, 2000."
  },
  {
    "type": "h2",
    "text": "1. Definitions"
  },
  {
    "type": "li",
    "text": "Platform: The OracyAI spoken language assessment platform, accessible at myoracy.ai."
  },
  {
    "type": "li",
    "text": "Oracy Group / We / Us: The entity operating the platform."
  },
  {
    "type": "li",
    "text": "User: Any person accessing the platform, including school administrators, teachers, and students."
  },
  {
    "type": "li",
    "text": "Institution: A school, educational centre, or organisation that has entered into an agreement with Oracy Group for access to the platform."
  },
  {
    "type": "li",
    "text": "Student User: A user who is a student and may be under the age of 18."
  },
  {
    "type": "li",
    "text": "Data Principal: As defined under the DPDP Act 2023, the individual to whom personal data relates."
  },
  {
    "type": "h2",
    "text": "2. Eligibility and Access"
  },
  {
    "type": "h3",
    "text": "2.1 Institutional Access"
  },
  {
    "type": "p",
    "text": "Access to OracyAI is granted to Institutions that have entered into a valid agreement with Oracy Group. Individual access is provided through credentials issued by the Institution or by Oracy Group."
  },
  {
    "type": "h3",
    "text": "2.2 Student Access"
  },
  {
    "type": "p",
    "text": "Student access to the platform requires prior setup by a teacher or administrator. Students under the age of 18 may only access the platform where verifiable parental or guardian consent has been obtained in accordance with the DPDP Act 2023 and our Privacy Policy."
  },
  {
    "type": "h3",
    "text": "2.3 Account Security"
  },
  {
    "type": "p",
    "text": "Users are responsible for maintaining the confidentiality of their login credentials. You must notify us immediately if you suspect any unauthorised access to your account."
  },
  {
    "type": "h2",
    "text": "3. Use of the Platform"
  },
  {
    "type": "h3",
    "text": "3.1 Permitted Use"
  },
  {
    "type": "p",
    "text": "The platform is provided solely for educational assessment purposes. Permitted uses include:"
  },
  {
    "type": "li",
    "text": "Submitting voice recordings for spoken language assessment"
  },
  {
    "type": "li",
    "text": "Viewing assessment scores and feedback"
  },
  {
    "type": "li",
    "text": "Managing student accounts and assessment sessions (for teachers and administrators)"
  },
  {
    "type": "h3",
    "text": "3.2 Prohibited Use"
  },
  {
    "type": "p",
    "text": "You must not:"
  },
  {
    "type": "li",
    "text": "Use the platform for any purpose other than educational spoken language assessment"
  },
  {
    "type": "li",
    "text": "Attempt to access data belonging to other users or institutions"
  },
  {
    "type": "li",
    "text": "Reverse-engineer, copy, or redistribute any part of the platform or its outputs"
  },
  {
    "type": "li",
    "text": "Upload recordings of any person who has not provided appropriate consent"
  },
  {
    "type": "li",
    "text": "Use the platform in any way that violates applicable Indian law"
  },
  {
    "type": "h2",
    "text": "4. Voice Recordings and Assessment Data"
  },
  {
    "type": "h3",
    "text": "4.1 Consent for Recordings"
  },
  {
    "type": "p",
    "text": "By submitting a voice recording through the platform, you (or the institution acting on your behalf) confirm that:"
  },
  {
    "type": "li",
    "text": "The person being recorded has been informed of the recording and its purpose"
  },
  {
    "type": "li",
    "text": "Where the person is under 18, verifiable parental or guardian consent has been obtained"
  },
  {
    "type": "li",
    "text": "The recording is made voluntarily for the purpose of spoken language assessment"
  },
  {
    "type": "h3",
    "text": "4.2 Assessment Outputs"
  },
  {
    "type": "p",
    "text": "Assessment scores and feedback generated by OracyAI are indicative and developmental in nature. They are intended to support teachers and educators, not to replace professional judgement. Oracy Group makes no representation that scores constitute a formal or legally binding assessment."
  },
  {
    "type": "h3",
    "text": "4.3 Data Processing"
  },
  {
    "type": "p",
    "text": "Voice recordings are processed by third-party automatic speech recognition providers (currently AssemblyAI) under our instruction and in accordance with our Privacy Policy. By submitting a recording, you consent to this processing."
  },
  {
    "type": "h2",
    "text": "5. Intellectual Property"
  },
  {
    "type": "p",
    "text": "All content, software, algorithms, scoring frameworks, and materials on the OracyAI platform are the intellectual property of Oracy Group or its licensors. Nothing in these Terms grants you any ownership rights in the platform or its outputs."
  },
  {
    "type": "p",
    "text": "Assessment reports generated for your students are provided for your institutional use. You may not republish, sell, or redistribute them without our prior written consent."
  },
  {
    "type": "h2",
    "text": "6. Data Protection"
  },
  {
    "type": "p",
    "text": "Our collection and use of personal data, including voice recordings, is governed by our Privacy Policy, which forms part of these Terms. By using the platform, you acknowledge that you have read and understood our Privacy Policy."
  },
  {
    "type": "p",
    "text": "Institutions are responsible for ensuring that their use of OracyAI complies with all applicable data protection obligations, including those owed to students and parents under the DPDP Act 2023."
  },
  {
    "type": "h2",
    "text": "7. Availability and Modifications"
  },
  {
    "type": "p",
    "text": "We aim to provide consistent access to the platform but do not guarantee uninterrupted availability. We reserve the right to:"
  },
  {
    "type": "li",
    "text": "Temporarily suspend access for maintenance or updates"
  },
  {
    "type": "li",
    "text": "Modify or discontinue features of the platform with reasonable notice"
  },
  {
    "type": "li",
    "text": "Update these Terms from time to time (see Section 12)"
  },
  {
    "type": "h2",
    "text": "8. Limitation of Liability"
  },
  {
    "type": "p",
    "text": "To the fullest extent permitted by applicable law:"
  },
  {
    "type": "li",
    "text": "Oracy Group is not liable for any indirect, incidental, or consequential loss arising from use of the platform"
  },
  {
    "type": "li",
    "text": "Our total liability for any claim arising from these Terms or your use of the platform shall not exceed the fees paid by your Institution to us in the 12 months preceding the claim"
  },
  {
    "type": "li",
    "text": "We are not liable for any loss arising from your failure to maintain the security of your account credentials"
  },
  {
    "type": "h2",
    "text": "9. Indemnity"
  },
  {
    "type": "p",
    "text": "You agree to indemnify and hold harmless Oracy Group and its affiliates from any claims, losses, or damages arising from:"
  },
  {
    "type": "li",
    "text": "Your breach of these Terms"
  },
  {
    "type": "li",
    "text": "Your violation of any applicable law, including the DPDP Act 2023"
  },
  {
    "type": "li",
    "text": "Your submission of recordings without appropriate consent"
  },
  {
    "type": "h2",
    "text": "10. Governing Law and Dispute Resolution"
  },
  {
    "type": "p",
    "text": "These Terms are governed by the laws of India. Any dispute arising from or in connection with these Terms shall first be attempted to be resolved through good-faith negotiation between the parties. If unresolved within 30 days, disputes shall be subject to the exclusive jurisdiction of the courts of India."
  },
  {
    "type": "h2",
    "text": "11. Grievance Redressal"
  },
  {
    "type": "p",
    "text": "In accordance with the Information Technology Act, 2000 and the DPDP Act 2023, any complaints or concerns regarding your use of the platform or these Terms may be directed to our Grievance Officer:"
  },
  {
    "type": "p",
    "text": "Grievance Officer"
  },
  {
    "type": "p",
    "text": "Oracy Group"
  },
  {
    "type": "p",
    "text": "Email: privacy@oracygroup.com"
  },
  {
    "type": "p",
    "text": "We will acknowledge complaints within 48 hours and aim to resolve them within 30 days."
  },
  {
    "type": "h2",
    "text": "1. Changes to These Terms"
  },
  {
    "type": "p",
    "text": "We may update these Terms from time to time. Material changes will be communicated to Institutions by email with reasonable notice before they take effect. Continued use of the platform after the effective date of updated Terms constitutes acceptance."
  },
  {
    "type": "h2",
    "text": "13. Contact"
  },
  {
    "type": "li",
    "text": "Email: privacy@oracygroup.com"
  },
  {
    "type": "li",
    "text": "Platform: myoracy.ai"
  },
  {
    "type": "li",
    "text": "Organisation: Oracy Group"
  },
  {
    "type": "p",
    "text": "These Terms and Conditions are effective from the date stated above and form a legally binding agreement between you and Oracy Group."
  }
];
